/* eslint-env jest */
import shouldShowBuyAllPromo from './buyAllPromoVisibility';

describe('shouldShowBuyAllPromo', () => {
  const promo = { id: 99 };
  const allDigital = { id: 42 };

  it('shows when a promo option exists and nothing blocks it', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: promo, hasSeniorBuyAll: false, builtOptionId: '7', allDigitalOption: allDigital,
    })).toBe(true);
  });

  it('hides when no promo option is configured', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: null, hasSeniorBuyAll: false, builtOptionId: '7', allDigitalOption: allDigital,
    })).toBe(false);
  });

  it('hides when the cart already carries a senior buy-all line', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: promo, hasSeniorBuyAll: true, builtOptionId: '7', allDigitalOption: allDigital,
    })).toBe(false);
  });

  it('hides when the customer just built the All Digital package (string id from URL vs number id)', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: promo, hasSeniorBuyAll: false, builtOptionId: '42', allDigitalOption: allDigital,
    })).toBe(false);
  });

  it('also matches when the built option id is a number', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: promo, hasSeniorBuyAll: false, builtOptionId: 42, allDigitalOption: allDigital,
    })).toBe(false);
  });

  it('still shows when the built option is a different (print) package', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: promo, hasSeniorBuyAll: false, builtOptionId: '7', allDigitalOption: allDigital,
    })).toBe(true);
  });

  it('shows when the all-digital option has not loaded yet (falls back to prior behavior)', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: promo, hasSeniorBuyAll: false, builtOptionId: '42', allDigitalOption: null,
    })).toBe(true);
  });

  it('treats undefined hasSeniorBuyAll as not-blocking', () => {
    expect(shouldShowBuyAllPromo({
      buyAllPromoOption: promo, hasSeniorBuyAll: undefined, builtOptionId: '7', allDigitalOption: allDigital,
    })).toBe(true);
  });
});
